import { CommunityInfo } from '@/components/CommunityInfo'

const WEBSITE_LINK = { url: 'https://example.com/the-monroe/', title: 'Visit Property Website', target: '_blank' }

export function CommunityInfoSandbox () {
	return (
		<div className='spaces:flex spaces:flex-col spaces:gap-16 spaces:max-w-[720px]'>
			<CommunityInfo
				name='The Monroe'
				address='55555 Longstreetname St, Cityname, AB 55555'
				websiteLink={WEBSITE_LINK}
				phone='(555) 555-5555'
				phoneHref='tel:5555555555'
			/>
			<CommunityInfo
				name='The Monroe'
				address='55555 Longstreetname St, Cityname, AB 55555'
				phone='(555) 555-5555'
				phoneHref='tel:5555555555'
			/>
			<CommunityInfo name='The Monroe' websiteLink={WEBSITE_LINK} />
			<CommunityInfo name='The Monroe' />
		</div>
	)
}
